module.exports = new __parcel__URL__("../../sp_logo.0ac3533f.svg").toString();